import React, { useEffect } from "react";
import HomePage from "../pages/greenshine/home_page";
import AppRoutes from "../routes";
import { Helmet } from "react-helmet";
import logo from '../assets/images/greenshine/green shine logo 1.png'
const GreenShineTemplate = () => {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    if (favicon) favicon.href = logo;
  }, []);
  return (
    <div>
      {" "}
      <React.Fragment>
        <Helmet>
          <title> Green Shine </title>
          <link
            rel="shortcut icon"
            type="image/jpg"
            href={logo}
          />
        </Helmet>
        <AppRoutes homePage={HomePage} />
      </React.Fragment>
    </div>
  );
};

export default GreenShineTemplate;
